import angular from 'angular';
import ngAnimate from 'angular-animate';
import SlideshowService from './slideshow.service';
import sliderApp from './slider';
'use strict';
var HeroController = /** @class */ (function () {
    /*@ngInject*/
    function HeroController() {
        this.errors = {
            havePageErrors: false,
            pageErrors: '',
            pageErrorType: ''
        };
        this.showAlert = false;
    }
    return HeroController;
}());
export { HeroController };
//HeroController.$inject = ['Slideshow'];
export default angular.module('directives.hero', [sliderApp, ngAnimate])
    .controller('HeroController', HeroController)
    //.factory('SlideshowResource', SlideshowResource)
    .service('Slideshow', SlideshowService)
    .component('hero', {
    template: require('./hero.html'),
    controller: HeroController
})
    .name;
//# sourceMappingURL=hero.component.js.map